import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStore, faBook, faWarning } from '@fortawesome/free-solid-svg-icons';
import ScrollTopButton from './ScrollTop';
import '../styles/ZahranStore.css';

const ZahranStore = ({ style }) => {
  return (
    <>
      <div className={`zahran-store-page ${style ? 'dark-mode' : ''}`}>
        <Container>
          {/* Header Section */}
          <Row className="justify-content-center">
            <Col lg={8} md={10} className="text-center">
              <div className="store-header">
                <div className="title-container">
                  <FontAwesomeIcon icon={faStore} className="store-icon" />
                  <h1 className="store-title">زهران استور</h1>
                </div>
                <p className="store-description">
                كتب الزوز كلها هتبقي هنا
                </p>
                
              </div>
            </Col>
          </Row>

          {/* Content Section */}
          <Row className="justify-content-center">
            <Col lg={8} md={10}>
              <div className="no-books-section">
                <div className="no-books-icon">
                  {/* <FontAwesomeIcon icon={faBook} /> */}
                </div>
                <div className="title-container">
                  <FontAwesomeIcon icon={faBook} className="store-icon" />

                {/* <FontAwesomeIcon icon={faWarning} className="store-icon" /> */}
                <h2 className="no-books-title">لا تتوفر كتب في الاستور حالياً</h2>
                </div>
                <p className="no-books-description">
                  سوف تتوفر قريباً
                </p>
                
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <ScrollTopButton />
    </>
  );
};

export default ZahranStore; 